import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './additional-requirements.component.scss';
import { MediaQueryService } from '../../services/media-query.service';
var AdditionalRequirements = /** @class */ (function (_super) {
    tslib_1.__extends(AdditionalRequirements, _super);
    function AdditionalRequirements(element) {
        var _this = _super.call(this, element) || this;
        _this.event.register('openModal', _this, _this.openModal.bind(_this));
        return _this;
    }
    AdditionalRequirements.prototype.init = function () {
        this.modals = Array.from(this.element.querySelectorAll('.js-add-req-modal'));
        this.modalLinks = Array.from(document.querySelectorAll('.js-add-req-modal-open'));
        this.closeButton = this.element.querySelector('.js-add-req-modal-close');
        this.currentPage = this.element.querySelector('.add-req__form-page--current');
        this.nextButton = this.element.querySelector('.js-add-req-next-step');
        this.prevButton = this.element.querySelector('.js-add-req-prev-step');
        this.resetButton = this.element.querySelector('.js-add-req-reset');
        this.submitButton = this.element.querySelector('.js-add-req-submit');
        this.formPageTotal = this.element.querySelectorAll('.add-req__form-page').length;
        this.currentStep = this.element.querySelector('.js-add-req-current-step');
    };
    AdditionalRequirements.prototype.bindEvents = function () {
        var _this = this;
        this.closeButton.addEventListener('click', function (event) { return _this.closeModal(); });
        this.modals.map(function (item) { return item.addEventListener('click', function (event) {
            _this.isClickOutsideModal(event);
        }); });
        this.modalLinks.map(function (item) { return item.addEventListener('click', function (event) {
            _this.openModals(event);
        }); });
        this.nextButton.addEventListener('click', function (event) { return _this.pageNext(event); });
        this.prevButton.addEventListener('click', function (event) { return _this.pagePrev(event); });
        this.resetButton.addEventListener('click', function (event) { return _this.resetForm(event); });
        window.addEventListener('resize', this.onResize.bind(this));
        window.addEventListener('orientationchange', this.onResize.bind(this));
    };
    AdditionalRequirements.prototype.onResize = function () {
        var _this = this;
        setTimeout(function () {
            _this.adjustContentHeight();
        }, 100);
    };
    AdditionalRequirements.prototype.isClickOutsideModal = function (event) {
        if (event.target === this.activeModal) {
            this.closeModal();
        }
    };
    AdditionalRequirements.prototype.openModals = function (event) {
        var modalId = event.target.getAttribute('data-modal');
        this.event.emit('openModal', {
            id: modalId
        });
    };
    AdditionalRequirements.prototype.closeModal = function () {
        var _this = this;
        this.activeModal.classList.add('modal--close');
        setTimeout(function () {
            _this.activeModal.classList.add('modal--closed');
        }, 250);
    };
    AdditionalRequirements.prototype.openModal = function (event, data) {
        this.activeModal = this.getModalById(data.id);
        this.activeModal.classList.remove('modal--close');
        this.activeModal.classList.remove('modal--closed');
        this.adjustContentHeight();
    };
    AdditionalRequirements.prototype.getModalById = function (id) {
        return document.querySelector("#" + id);
    };
    AdditionalRequirements.prototype.adjustContentHeight = function () {
        var _this = this;
        var headerHeight = this.element.querySelector('.add-req__header').clientHeight;
        var footerHeight = this.element.querySelector('.add-req__footer').clientHeight;
        var containerHeight = this.element.querySelector('.add-req__modal-content').clientHeight;
        var newContentHeight = containerHeight - footerHeight - headerHeight;
        var content = this.element.querySelector('.add-req__content');
        if (MediaQueryService.getMediaQuery() !== 'small' && MediaQueryService.getMediaQuery() !== 'x-small') {
            if (newContentHeight > 1) {
                content.style.height = newContentHeight + "px";
            }
            else {
                setTimeout(function () {
                    _this.adjustContentHeight();
                }, 100);
            }
            content.style.marginBottom = footerHeight + "px";
        }
        else {
            content.style.height = 'auto';
            content.style.marginBottom = '0';
        }
    };
    AdditionalRequirements.prototype.pageNext = function (event) {
        event.preventDefault();
        if (!this.nextButton.classList.contains('button--disabled')) {
            var currentPageId = parseInt(this.currentPage.id.replace(/\D/g, ''));
            var nextPageId = currentPageId + 1;
            var nextPage = this.element.querySelector('#p' + nextPageId);
            this.currentPage.classList.remove('add-req__form-page--current');
            this.currentPage.classList.remove('add-req__form-page--left');
            this.currentPage.classList.remove('add-req__form-page--right');
            nextPage.classList.add('add-req__form-page--current');
            nextPage.classList.add('add-req__form-page--right');
            if (nextPageId === this.formPageTotal) {
                this.disableNextButton();
                this.showResetButton();
                this.nextButton.classList.add('add-req__button--hidden');
                this.submitButton.classList.remove('add-req__button--hidden');
            }
            this.enablePrevButton();
            this.updateStepIndicator(nextPageId, currentPageId);
            this.currentPage = nextPage;
        }
    };
    AdditionalRequirements.prototype.pagePrev = function (event) {
        event.preventDefault();
        if (!this.prevButton.classList.contains('button--disabled')) {
            var currentPageId = parseInt(this.currentPage.id.replace(/\D/g, ''));
            var prevPageId = currentPageId - 1;
            var prevPage = this.element.querySelector('#p' + prevPageId);
            this.currentPage.classList.remove('add-req__form-page--current');
            this.currentPage.classList.remove('add-req__form-page--left');
            this.currentPage.classList.remove('add-req__form-page--right');
            prevPage.classList.add('add-req__form-page--current');
            prevPage.classList.add('add-req__form-page--left');
            if (prevPageId === 1) {
                this.disablePrevButton();
            }
            this.submitButton.classList.add('add-req__button--hidden');
            this.nextButton.classList.remove('add-req__button--hidden');
            this.enableNextButton();
            this.hideResetButton();
            this.updateStepIndicator(prevPageId, currentPageId);
            this.currentPage = prevPage;
        }
    };
    AdditionalRequirements.prototype.pageStart = function () {
        var startPage = this.element.querySelector('#p1');
        var currentPageId = parseInt(this.currentPage.id.replace(/\D/g, ''));
        this.currentPage.classList.remove('add-req__form-page--current');
        this.currentPage.classList.remove('add-req__form-page--left');
        this.currentPage.classList.remove('add-req__form-page--right');
        startPage.classList.add('add-req__form-page--current');
        startPage.classList.add('add-req__form-page--left');
        this.submitButton.classList.add('add-req__button--hidden');
        this.nextButton.classList.remove('add-req__button--hidden');
        this.disablePrevButton();
        this.enableNextButton();
        this.hideResetButton();
        this.updateStepIndicator(1, currentPageId);
        this.currentPage = startPage;
    };
    AdditionalRequirements.prototype.resetForm = function (event) {
        event.preventDefault();
        document.querySelector('form').reset();
        this.pageStart();
    };
    AdditionalRequirements.prototype.updateStepIndicator = function (newIndicator, oldIndicator) {
        this.element.querySelector('#i' + oldIndicator).classList.remove('add-req__steps-item--current');
        this.element.querySelector('#i' + newIndicator).classList.add('add-req__steps-item--current');
        this.updateStepText(newIndicator);
    };
    AdditionalRequirements.prototype.updateStepText = function (step) {
        this.currentStep.textContent = step;
    };
    AdditionalRequirements.prototype.disablePrevButton = function () {
        this.prevButton.classList.add('button--disabled');
    };
    AdditionalRequirements.prototype.enablePrevButton = function () {
        this.prevButton.classList.remove('button--disabled');
    };
    AdditionalRequirements.prototype.disableNextButton = function () {
        this.nextButton.classList.add('button--disabled');
    };
    AdditionalRequirements.prototype.enableNextButton = function () {
        this.nextButton.classList.remove('button--disabled');
    };
    AdditionalRequirements.prototype.showResetButton = function () {
        this.resetButton.classList.remove('add-req__reset--hidden');
    };
    AdditionalRequirements.prototype.hideResetButton = function () {
        this.resetButton.classList.add('add-req__reset--hidden');
    };
    return AdditionalRequirements;
}(Base));
export { AdditionalRequirements };



//////////////////
// WEBPACK FOOTER
// ./components/additional-requirements/additional-requirements.component.ts
// module id = 79
// module chunks = 0